require('./bootstrap');

import {ValidatePhones} from './validate_phones';

ValidatePhones('input[type=tel]', bootstrap.Tooltip);



window.csrf_token = function()
{
    return $('meta[name=csrf-token]').attr('content');
}


window.reloadTooltips = function(selector)
{
    if(!selector) selector = '[data-bs-toggle="tooltip"]';
    var tooltipTriggerList = [].slice.call(document.querySelectorAll(selector))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    });

}
$(document).ready(function(){
    reloadTooltips();

    $('.checkall-btn[data-index]').each((k, btn) => {
        var i = $(btn).attr('data-index');
        var all_checked = $('input[data-index="' + i + '"]:not(.checkall-btn)').toArray().reduce((acc, v) => acc && $(v).prop('checked'), true);
        if(all_checked) $(btn).prop('checked', true);
    });

    $('.checkall-btn[data-domain]').each((k, btn) => {
        var i = $(btn).attr('data-domain');
        var all_checked = $('input[data-domain="' + i + '"]:not(.checkall-btn)').toArray().reduce((acc, v) => acc && $(v).prop('checked'), true);
        if(all_checked) $(btn).prop('checked', true);
    });


    $('body').on('click', '.checkall-btn[data-index]', function(){
       var i = $(this).attr('data-index');
       $('input[data-index=' + i + ']:not(.checkall-btn)').prop('checked', $(this).prop('checked'));
    });

    $('body').on('click', '.checkall-btn[data-domain]', function(){
       var d = $(this).attr('data-domain');
       $('input[data-domain=' + d + ']:not(.checkall-btn)').prop('checked', $(this).prop('checked'));
    });



    $('.qizaga-upload-area').on('drop', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var drop_area = $(this);

        drop_area.text("UPLOADING..");
        // todo: select file uploader based on extension
        // add uploader automatically
        var files = e.originalEvent.dataTransfer.files;
        var addFile = ((target) =>
            function(){
                for(var i=0;i<files.length;i++)
                {
                    var row = addRow($('button[data-target="' + target + '"]')); // addRow is defined in the form
                    // it returns the new file group
                    var uploader = row.find('.qizaga-file');
                    var domain = target === '#Pictures' ? 'asset' : undefined;
                    QizagaFileUpload(files[i], uploader,
                        (r) => drop_area.text("UPLOADED") && setTimeout(() => drop_area.text('DROP FILES HERE'), 900),
                        domain,
                        () => drop_area.text("UPLOAD FAILED") && setTimeout(() => drop_area.text('DROP FILES HERE'), 2000));

                }
            });
        $.confirm({
            closeIcon: true,
            title: 'Where to save the files?',
            content: '',
            buttons: {
                pictures: addFile('#Pictures'),
                files: addFile('#Files'),
                "sales documents": addFile('#SalesDocuments')
            }
        });


    }).on('dragenter', function (e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).text("DROP FILES HERE");
    }).on('dragover', function (e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).text("DROP FILES HERE");
    });



    $('body').on('click', 'label.qizaga-has-file', function(){
        const url = $(this).parent().find('.qizaga-file input[type=hidden]').val();
        if(url) window.open(url);
    }).on('click', 'a.qizaga-file-rm', function(){
        $(this).parent().find('.qizaga-file input[type=hidden]').val('').prop('disabled', true);
        $(this).parent().find('label.qizaga-has-file').removeClass('qizaga-has-file').text('');
    }).on('click', ".qizaga-file .btn", function(){
        var uploader = $(this).parents('.qizaga-file:first');
        var files = uploader.find('input[type=file]')[0].files;
        var domain = $(this).data('domain') || '';

        if(files.length > 0 ){
            QizagaFileUpload(files[0], uploader, null, domain)
        }else{
            alert("Please select a file.");
        }
    });
});

window.QIZAGA_MAX_UPLOAD_BYTES = 50 * 1024 * 1024; // must match post_max_size / upload_max_filesize in php.ini

window.QizagaFileUpload = function(file, uploader, on_success, domain, on_error){
    var fd = new FormData();

    fd.append('file', file);
    fd.append('_token', csrf_token());
    if(domain) fd.append('domain', domain);

    var showError = function(xhr, reason){
        reason = reason || (xhr && xhr.status === 400
            ? 'invalid or disallowed file type'
            : 'server error');
        alert('File upload failed: ' + file.name + ' (' + reason + ')');

        if(on_error){
            on_error(xhr);
        }
    };

    if(file.size > window.QIZAGA_MAX_UPLOAD_BYTES){
        showError(null, 'file is too large, max ' + Math.floor(window.QIZAGA_MAX_UPLOAD_BYTES / 1024 / 1024) + ' MB');
        return;
    }

    $.ajax({
        url: '/files/upload',
        type: 'post',
        data: fd,
        contentType: false,
        processData: false,
        success: function(response){
            // the endpoint returns a bare URL string; anything else (e.g. a PHP
            // warning + error JSON served with 200) is a failure
            var is_url = typeof response === 'string' && /^(https?:\/\/|\/)/.test(response.trim());
            if(!is_url) {
                showError(null, 'unexpected server response -- please check file size and format');
                return;
            };
            if(uploader)
            {
                uploader.find('input[type=hidden]').val(response).prop('disabled', false);
                uploader.parent().find('label').addClass('qizaga-has-file recently-uploaded').text(file.name);
            }

            if(on_success){
                on_success(response);
            }
        },
        error: showError,
    });
}
$(document).ready(function() {
    $('body').on('keyup', 'input[type=text]:not(.any-case)', function(e) {
        const val = $(this).val();
        if(val.toUpperCase() !== val)
            $(this).val(val.toUpperCase());
    });//

});
window.sendAssetsToEmail = function(dt){
    window.location = _buildUrl(dt, 'sendAssetsToEmail');

}
window.addQueryParams = function(values){
    const url = new URL(document.location.href);
    var search_params = url.searchParams;

    Object.keys(values).map(function(k){
        search_params.set(k, values[k])
    })
    url.search = search_params.toString();
    return url.toString();
}
window.showAlertMessage = function(msg, permanent){
    var html = '<div class="alert alert-primary w-25 floating-alert" role="alert">' +
        msg + '<button class="btn btn-primary btn-sm" style="float:right;" onclick="$(\'.floating-alert\').fadeOut();">OK</button>' +
    '</div>'; // todo
    $('#qizaga-content').prepend(html);

    $('.floating-alert').fadeIn(500);

    if (!permanent) setTimeout(() => $('.floating-alert').fadeOut(), 10000);
}
window.updateRecords = function(ids, domain, data, $base_ui, onSave){
    data['_token'] = csrf_token();
    data.inplace = 1;

    ids.map(function(id){

        $.post('/' + domain + '/' + id, data, function(res){

            if($base_ui){
                const t =
                bootstrap.Tooltip.getOrCreateInstance($base_ui,{
                    title: res.message || 'Saved',
                    trigger: 'manual',
                    placement: 'right',
                });
                t.show();

                setTimeout(function (){t.dispose();}, 1000);
            }
            if(onSave){
                onSave(res);
            }
        }, 'json');
    });
}


window.selectExcelProfile = function(e)
{
    var btn = $('button.buttons-excel');
    $.get('/excel_profile', {
        "draw":"2",
        "columns":{
            "0":{
                "data":"system_id"
            },
            "1":{
                "data":"name"
            },
            "2":{
                "data":"created_at"
            },
            "3":{
                "data":"updated_at"
            },
            "4":{
                "data":"action",
                "searchable":"false",
                "orderable":"false"
            }
        },
        "order":[
            {
                "column":"1",
                "dir":"desc"
            }
        ],
        "start":"0",
        "length":"100",
        "search":{
            "value":""
        }
    }, function(data){
        data = data.data || [];

        if(!data.length){
            $.dialog({title: 'Excel Export', content: 'No export profiles available'});
            return;
        }

        var options = '<option value="">----Select Profile----</option>';
        for(var i =0; i<data.length;i++)
        {
            options += '<option value="'+data[i].id+'">'+data[i].name+'</option>';
        }

        $.confirm({
            title: 'Select Export Profile',
            content: '<select id="ExportProfileSelector" class="form-select">'+options+'</select>',
            buttons: {
                export: {
                    text: 'Export',
                    btnClass: 'btn-primary',
                    action: function(){
                        exportExcel();
                    },
                },
                cancel: {},
            },
        });
    }, 'json');

}
window.exportExcel = function(){
    var id = $('#ExportProfileSelector').val();
    $.post('/excel_profile/select/' + id, {_token: csrf_token()}, function(){
        $("button.buttons-excel").click();
    }, 'json')
}

window.addRow = function (e){
    var proto = $(e).attr("data-prototype");
    var target = $(e).attr('data-target');
    return $(proto.replaceAll("__NAME__", $(target).length)).appendTo(target);
}
window.closeOnSave = function(frame){
    if(frame.contentWindow.location.pathname === '/saved'){
        window.showFramePage.currentFrame.close();
        window.loadPage(window.Pagination.page);
        window.showAlertMessage('Saved');
    }
}
window.showFramePage = function(url){
    $.confirm({
        title: false,
        closeIcon: true,
        content: "",
        columnClass: 'iframe-page',
        buttons: {cancel: {isHidden: true}},
        onContentReady: function(){
            window.showFramePage.currentFrame = this;
            $('<iframe onload="closeOnSave(this)" allowtransparency="yes" scrolling="no" />').attr('src', url).addClass('iframe-page').appendTo(this.$content);
        }
    })
}

window.quickEdit = function(id){

    $.get('/edit_profile', {
        "draw":"2",
        "columns":{
            "0":{
                "data":"id"
            },
            "1":{
                "data":"name"
            },
        },
        "start":"0",
        "length":"-1"
    }, function(res){
        var buttons = res.data.map(function(p){
            return {text: p.name, action: function(){ showFramePage('/asset/' + id + '?inplace=1&edit_profile_id=' + p.id); }};
        });
        buttons.cancel = {};

        $.confirm({
            title: 'Please Select Edit Profile',
            content: '',
            buttons: buttons
        });
    }, 'json');



}

$(document).ready(function() {
    $('body').on('click', 'input[type=date]', e => e.preventDefault());
    function saveEditable($td){
        const table = window.LaravelDataTables["crud-table"];
        const name = table
            .column( $td.index()+':visIdx' )
            .dataSrc();
        const content = $td.hasClass('crud-select') ? $td.find('select').val() : $td.text();
        const id = table.row( $td.parent() ).data().id;
        const data = {};
        data[name] = content;
        data['inplace'] = 1;
        data['_token'] = csrf_token();
        var base_url = (new URL(window.LaravelDataTables["crud-table"].ajax.url())).pathname

        $.post(base_url + '/' + id, data, function(res){

            const t =
                bootstrap.Tooltip.getOrCreateInstance($td,{
                    title: res.message || 'Saved',
                    trigger: 'manual',
                    placement: 'right',
                });
            t.show();

            setTimeout(function (){t.dispose();}, 1000);
        }, 'json').fail(r => {
            if(r && r.responseJSON) {
                if(r.responseJSON.message) {
                    alert(r.responseJSON.message)
                }
            }
        });

    }
    $('body').on('click', '.crud-editable', function(e) {
        if(!$(this).hasClass('crud-select'))
            $(this).prop('contentEditable', true);

    }).on('keydown', '.crud-editable', function(e){
        if(e.originalEvent.code === 'Enter') {
            e.preventDefault();
            $(this).blur();
            return false;
        }
    }).on('focusout', '.crud-editable:not(.crud-select)', function(e){
        saveEditable($(this));
    }).on('change', '.crud-editable.crud-select > select', function(e){
        saveEditable($(this).parent());
    });


});
